// extracted by mini-css-extract-plugin
export default {"raw-data":"RawData_raw-data__k8ZTb"};